  <table class="wire-count-table"  id="dpc_{{ tSCount }}">
    <tr *ngFor="let row of wireData; let i = index"  id="pcDetails_{{ tSCount }}_{{ i }}" class="slipDetailsPC_{{ tSCount }}">
      <td [attr.rowspan]="cell.RowSpan" *ngFor="let cell of row; let j = index">
        <div *ngIf="i == 0" class="end-count-head">{{ cell.Value }}</div>
        <div *ngIf="i == 1" class="end-count-head bg">{{ cell.Value }}</div>
        <div *ngIf="i > 1 && j == 0" class="permutation-number">
          {{ cell.Value }}
        </div>
        <div *ngIf="i > 1 && j > 0 && j !== row.length - 1" class="wire-count-input">
          {{ cell.Value }}
        </div>

        <div class="select-box" *ngIf="i > 1 && j == row.length - 1">
          <div class="check"></div>
        </div>

      </td>
    </tr>
  </table>
